import React, { FC } from 'react';

import { Modal } from 'antd';

// Shared UI Library Components
import { CustomButton, CustomIcon, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './delete-cost-per-session-modal.scss';

type TDeleteCostPerSessionModalProps = {
  open: boolean;
  isLastItem?: boolean;
  title?: string;
  onClose?: (state: boolean) => void;
}

export const DeleteCostPerSessionModal: FC<TDeleteCostPerSessionModalProps> = (
  { open = false, title, isLastItem = false, onClose = () => {} }: TDeleteCostPerSessionModalProps
) => {

  return (
    <Modal
      rootClassName="delete-cost-per-session-modal"
      width={ '395px' }
      open={ open }
      centered={ true }
      closeIcon={ false }
      title={ title ? title : 'Are you sure you want to delete Session and Cost?' }
      footer={ [
        <CustomButton key="no" text={ 'No' } type={ 'text' } onClick={ () => onClose(false) }/>,
        <CustomButton key="yes" text={ 'Yes' } onClick={ () => onClose(true) }/>
      ] }
      onCancel={ () => onClose(false) }
    >
      <div className="delete-cost-per-session-modal--body" hidden={ !isLastItem }>
        <div className="body-item body-item--error-message">
          <CustomIcon name={ EIconName.Warning }/> Since this is the only service set up, this action will automatically
          change the Consultants' status to Inactive.
        </div>
      </div>
    </Modal>
  )
};
